import React from 'react'
import BoatsPage from './BoatsPage'

export default function MotorsailersPage() {
  return <BoatsPage categoryFilter="Motorsejler" titleOverride="Motorsejlere til salg" />
}
